const ForgeLogo = ({ fill = "#fff", width = 30.45, height = 26.53, className = "", ...props }) => {
  return (
    <svg viewBox="0 0 30.45 26.53" width={width} height={height} xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" {...props}>
      <polygon fill={fill} points="7.71 4.56 11.64 4.56 11.64 8.75 0 8.75 2.45 11.2 10.68 11.2 11.51 12.03 11.51 17.61 8.31 14.41 5.08 14.41 11.92 21.26 11.92 24.5 13.95 26.53 13.95 0 7.71 4.56" />
      <polygon
        fill={fill}
        points="22.74 4.56 18.81 4.56 18.81 8.75 30.45 8.75 28 11.2 19.77 11.2 18.94 12.03 18.94 17.61 22.13 14.41 25.37 14.41 18.52 21.26 18.52 24.5 16.5 26.53 16.5 0 22.74 4.56"
      />
    </svg>
  );
};

export default ForgeLogo;
